import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'xyz-shared-tag-group',
    imports: [],
    templateUrl: './tag-group.component.html',
    styleUrls: ['./tag-group.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TagGroupComponent {}
